import { NgModule } from '@angular/core';
import { PopupService, UTabViewModule } from '@local/ui-infra';
import { SharedModule } from '@shared/shared.module';
import { SharedBarModule } from '../../components/shared-bar.module';
import { ChatPageModule } from '../chat-page/chat-page.module';
import { CollectionsPageModule } from '../collections-page/collections-page.module';
import { HomeSearchPopupModule } from '../home-search-popup/search-popup.module';
import { ResultsModule } from '../results/results.module';
import { DefaultViewSidePanelHomeComponent } from './components/default-view-side-panel-home/default-view-side-panel-home.component';
import { HomeSidePanelComponent } from './components/home-side-panel/home-side-panel.component';
import { SearchSidePanelComponent } from './components/search-side-panel/search-side-panel.component';
import { SidePanelComponent } from './components/side-panel/side-panel.component';

const components = [SidePanelComponent, HomeSidePanelComponent, SearchSidePanelComponent, DefaultViewSidePanelHomeComponent];
@NgModule({
  declarations: [components],
  imports: [SharedModule, SharedBarModule, ResultsModule, UTabViewModule, CollectionsPageModule, ChatPageModule, HomeSearchPopupModule],
  providers: [{ provide: PopupService, useClass: PopupService }],
  exports: [...components],
})
export class SidePanelModule {}
